// removed by extract-text-webpack-plugin
module.exports = {"bulb_gradient_stop_1":"bulb_gradient_stop_1__3u2PO","bulb_gradient_stop_2":"bulb_gradient_stop_2__1OO8-","thermometer_max_label":"thermometer_max_label__3QGIS","thermometer_min_label":"thermometer_min_label__1Kow6","thermometer_outline":"thermometer_outline__3RDl5","thermometer_empty":"thermometer_empty__1c6YT","thermometer_extremes":"thermometer_extremes__2RUA0","thermometer_mercury":"thermometer_mercury__2twN_","thermometer_scale":"thermometer_scale__10Z54"};


//////////////////
// WEBPACK FOOTER
// ./components/thermometer/style.scss
// module id = f5I/
// module chunks = 0